import { useEffect, useState } from 'react';

export function useInnerValue(
  value?: string,
  onChange?: (value: string, ...rest: any[]) => void
): { innerValue: string; handleChange: (value: string, ...rest: any[]) => void } {
  const [innerValue, setInnerValue] = useState('');

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  const handleChange = (value: string, ...rest: any[]) => {
    setInnerValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return { innerValue, handleChange };
}
